<mat-spinner [diameter] ="30"></mat-spinner>